import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SideBarMenuSharedService {
  isMenuExpanded = new EventEmitter<boolean>();;

  // Tracks the last emitted value so callers that just need to know "is the sidebar drawer
  // currently open right now" (e.g. the Android hardware back-button handler in
  // TallyKeypadService — see its own comment for why that's where this gets consumed) don't
  // need their own subscription just to read current state. isMenuExpanded itself stays a
  // plain EventEmitter, unchanged, so every existing .emit(...) call site keeps working as-is.
  isOpen = false;

  constructor() {
    this.isMenuExpanded.subscribe((expanded) => { this.isOpen = expanded; });
  }
}
